import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Accès",
  "lead": "À l’échelle mondiale, 88 % des enfants achèvent le cycle primaire, 78 % des adolescents achèvent le premier cycle du secondaire et 59 % des jeunes achèvent le deuxième cycle du secondaire."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, Highlight, HighlightByIndex, IndicatorReference, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky, Tooltip} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!Highlight) _missingMdxReference("Highlight", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!Tooltip) _missingMdxReference("Tooltip", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_ACCESS"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Le monde n’a pas tenu sa promesse qui était d’envoyer tous les enfants à l’école primaire avant 2015. Le nouvel objectif en matière d’éducation, l’ODD 4, a fixé un niveau d’ambition encore plus élevé, préconisant que tous les jeunes achèvent leurs études secondaires avant l’horizon 2030. Pour y parvenir, tous les enfants en âge de commencer l’école auraient dû y entrer en 2018 mais, en réalité, seuls 70 % d’entre eux l’avaient fait dans les pays à faible revenu, par exemple."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "scolarité-préprimaire",
      children: "Scolarité préprimaire"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.2.2",
      children: _jsxs(_components.p, {
        children: ["La ", _jsx(_components.strong, {
          children: "fréquentation d’un établissement préprimaire"
        }), " est un point de départ décisif dans le parcours éducatif des enfants. Pourtant, dans les pays à faible revenu, seuls 48 % des enfants sont inscrits à l'école un an avant l’âge officiel d’entrée dans l’enseignement primaire."]
      })
    }), "\n", _jsx(_components.p, {
      children: "À l’échelle mondiale, la participation l’année précédant l’école primaire est passée de 64 % en 2003 à 75 % en 2024, principalement grâce aux progrès réalisés au début des années 2000. Les avancées ont largement stagné depuis 2015, laissant de nombreux enfants sans accès à l’éducation préprimaire."
    }), "\n", _jsx(_components.p, {
      children: "Certains pays ont enregistré des progrès spectaculaires. En Azerbaïdjan, par exemple, le taux de participation est passé de 16 % en 2000 à 83 % en 2024. En RDP lao, il est passé de 10 % à 67 % au cours de la même période."
    }), "\n", _jsx("p", {
      children: _jsxs(_components.p, {
        children: ["La ", _jsx(HighlightByIndex, {
          index: "0",
          children: "République dominicaine"
        }), " et le\n", _jsx(HighlightByIndex, {
          index: "1",
          children: "Sénégal"
        }), ",\nprésentés ci-après, sont deux exemples de pays ayant connu une augmentation constante de la scolarité préprimaire,\nbien qu’il existe aujourd’hui d’immenses disparités entre les deux pays.\nSélectionnez votre pays pour connaître ses progrès."]
      })
    }), "\n", _jsx(_components.p, {
      children: "Trois enfants sur quatre fréquentent l’enseignement préprimaire un an avant d’entrer à l’école primaire."
    }), "\n", _jsx(Figure, {
      id: "PREPRIM"
    }), "\n", _jsx(_components.h2, {
      id: "participation-au-delà-de-lâge-normal",
      children: "Participation au-delà de l’âge normal"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.1.65",
      children: _jsxs(_components.p, {
        children: ["Nous n’évoquons pas assez le fait que, dans un certain nombre de pays, plus d’un quart des enfants qui s’inscrivent à l’école primaire ont ", _jsx(_components.strong, {
          children: "dépassé l’âge normal"
        }), ", autrement dit qu’ils sont nettement plus âgés que les élèves de leur niveau d’étude ne sont censés l’être. Cela a d’importantes répercussions sur leur avenir, et fait augmenter par la suite la probabilité de redoubler, d’échouer aux examens et finalement d’abandonner l’école."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Ce graphique sur la ", _jsx(_components.strong, {
        children: "participation à l’éducation"
      }), " indique l’âge des enfants, des adolescents et des jeunes lorsqu’ils fréquentent l’enseignement préprimaire, primaire, des premier et deuxième cycles du secondaire et l’enseignement post-secondaire. Les différentes couleurs indiquent combien d’enfants ont dépassé l’âge normal par rapport à leur niveau d’étude. La zone grisée montre le pourcentage d’enfants et d’adolescents déscolarisés par âge."]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "OVERAGE"
        })
      }), _jsx(ScrollySection, {
        id: "KHM",
        children: _jsxs(_components.p, {
          children: ["Au ", _jsx(Highlight, {
            children: "Cambodge"
          }), ", la plupart des enfants de 10 ans devraient aller à l’école,\npourtant 21 % ne sont toujours pas scolarisés à cet âge. Beaucoup d’entre eux sont trop âgés par\nrapport à leur niveau d’étude. Certains élèves âgés de 14 ans sont encore à l’école primaire,\npar exemple."]
        })
      }), _jsx(ScrollySection, {
        id: "LBR",
        children: _jsxs(_components.p, {
          children: ["Le taux d’élèves en retard pour leur âge est encore plus élevé dans les pays comme le", " ", "\n", _jsx(Highlight, {
            children: "Libéria"
          }), ", où 28 % des enfants de 10 ans sont scolarisés dans le préprimaire\net où 20 % des jeunes de 18 ans fréquentent encore l’école primaire."]
        })
      }), _jsx(ScrollySection, {
        id: "NPL",
        children: _jsxs(_components.p, {
          children: [_jsx(Highlight, {
            children: "Le Nepal"
          }), " est confronté au même problème"]
        })
      }), _jsx(ScrollySection, {
        id: "MWI",
        children: _jsxs(_components.p, {
          children: ["de même que le ", _jsx(Highlight, {
            children: "Malawi"
          }), "."]
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "enfants-non-scolarisés",
      children: "Enfants non scolarisés"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.4",
      children: [_jsxs(_components.p, {
        children: ["À l’échelle mondiale, 273 millions d’enfants et de jeunes ne sont ", _jsx(_components.strong, {
          children: "pas scolarisés"
        }), ". Un nouveau ", _jsx(_components.a, {
          href: "https://www.education-estimates.org",
          children: "modèle élaboré par l’Institut de statistique de l’UNESCO et le Rapport mondial de suivi sur l’éducation"
        }), " suggère que la population non scolarisée a augmenté ces dernières années."]
      }), _jsx(_components.p, {
        children: "Les conflits sont l’une des causes principales de stagnation. Malheureusement, les conflits signifient également que la disponibilité et la qualité des données se détériorent, même si certains pays continuent de communiquer des estimations."
      }), _jsx(_components.p, {
        children: "Les taux d’enfants non scolarisés continuent de diminuer, mais plus lentement."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "OOSRATE"
          })
        }), _jsx(ScrollySection, {
          id: "ECU,PRY",
          children: _jsxs(_components.p, {
            children: [_jsx(Highlight, {
              children: "L'Équateur"
            }), " et ", _jsx(Highlight, {
              children: "le Paraguay "
            }), " ont progressé selon\ndes voies très différentes. Au secondaire, le taux d’enfants\nnon scolarisés a chuté en Équateur, tandis qu’il a augmenté au\nParaguay."]
          })
        }), _jsx(ScrollySection, {
          id: "ERI,ETH",
          children: _jsxs(_components.p, {
            children: [_jsx(Highlight, {
              children: "L’Érythrée"
            }), " et ", _jsx(Highlight, {
              children: "l’Éthiopie "
            }), " présentent aussi des\ntaux de progression très éloignés. Les séquelles du conflit en Érythrée ont eu un impact visible\nsur l’accès à l’éducation, tandis que l’Éthiopie a donné la priorité à l’éducation dans son\nbudget, ce qui a permis de réduire le taux d’enfants non scolarisés au primaire."]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "La croissance démographique explique également que le nombre d’enfants non scolarisés ne recule pas."
    }), "\n", _jsxs(_components.p, {
      children: ["En Afrique subsaharienne, la ", _jsx(HighlightByIndex, {
        index: "2",
        children: "population en âge de fréquenter l’école"
      }), " primaire a quasiment doublé entre 2000 et 2024. Par conséquent, bien que le ", _jsx(HighlightByIndex, {
        index: "0",
        children: "taux d’enfants non scolarisés "
      }), " ait diminué de près de moitié au cours de cette période, le ", _jsx(HighlightByIndex, {
        index: "1",
        children: "nombre d’enfants non scolarisés "
      }), " n’a pratiquement pas évolué."]
    }), "\n", _jsx(Figure, {
      id: "OOSREL"
    }), "\n", _jsx(_components.h2, {
      id: "achèvement",
      children: "Achèvement"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.2",
      children: [_jsxs(_components.p, {
        children: ["L’ODD 4 a pour finalité absolue y ", _jsx(_components.strong, {
          children: "l’achèvement"
        }), " universel du second cycle de l’enseignement secondaire, et non la simple scolarisation. Et cela en dépit du fait que, dans de nombreux pays, l’éducation n’est gratuite et obligatoire que jusqu’au premier cycle du secondaire tout au plus."]
      }), _jsx(_components.p, {
        children: "Le monde n’est pas près de parvenir à l’achèvement universel du cycle primaire avant l’échéance fixée, ni à plus forte raison à l’achèvement du second cycle du secondaire. Selon la tendance actuelle, moins de deux jeunes sur trois environ termineront l’enseignement secondaire en 2030."
      }), _jsxs(_components.p, {
        children: ["L’indicateur porte sur des enfants pouvant achever des cycles d’enseignement jusqu’à 3 à 5 ans après l’âge officiel de fin d’études – ce qui peut être défini comme ", _jsx(Tooltip, {
          title: "l’achèvement des études à l’âge voulu",
          content: "Les enfants qui achèvent des cycles d’enseignement jusqu’à 3 à 5 ans après l’âge normal de la dernière année ",
          children: "l’achèvement des études à l’âge voulu"
        }), ". Mais de nombreux enfants achèvent leurs études avec un plus grand retard, ce qui peut être défini comme ", _jsx(Tooltip, {
          title: "l’achèvement ultérieur",
          content: "Les enfants qui achèvent des cycles d’enseignement jusqu’à 8 ans après l’âge normal de la dernière année",
          children: "ultimate completion"
        }), "."]
      }), _jsxs(_components.p, {
        children: ["Sur le graphique ci-après, en Angola, par exemple, un écart de presque 20 points de pourcentage sépare ", _jsx(HighlightByIndex, {
          index: "0",
          children: "l’achèvement à l’âge voulu "
        }), " (64%) de ", _jsx(HighlightByIndex, {
          index: "1",
          children: "l’achèvement ultérieur "
        }), " completion (82%) au niveau primaire."]
      }), _jsx(Figure, {
        id: "COMPLETION"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "conclusion",
      children: "Conclusion"
    }), "\n", _jsx(_components.p, {
      children: "Savoir quand sont scolarisés les enfants, à quel âge et s’ils vont au bout de leurs études sont autant de préoccupations politiques essentielles."
    }), "\n", _jsx(_components.p, {
      children: "Les prochains thèmes abordés sur ce site nous permettent de comprendre si nous sommes près de réaliser l’équité dans l’éducation, ce que les élèves apprennent, quelle est la qualité de leur éducation et qui la finance."
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.education-estimates.org",
            children: "Visualizing Indicators of Education for the World (VIEW)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://resourcecentre.savethechildren.net/library/education-against-odds-meeting-marginalised-childrens-demands-quality-education",
            children: "Education above the odds – Save the Children"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "http://uis.unesco.org/sites/default/files/documents/ip61-combining-data-out-of-school-children-completion-learning-offer-more-comprehensive-view-sdg4.pdf",
            children: "Combining data on out-of-school children, Completion and learning to offer a more comprehensive view on SDG 4"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
